import heroBg from '../assets/images/34b86dbf-7f48-4c97-9aa0-0c6458573916.png';
import './Hero.css';

const Hero = ({ style, title, subtitle }) => {
  return (
    <section id="hero" className="hero">
      <img
        src={heroBg}
        alt="Handyman tools background"
        className="hero-bg"
        fetchPriority="high"
      />
      <div className="hero-content" style={style}>
        <h1 className="hero-title">{title || "Professional Handyman Services in Northridge"}</h1>
        <p className="hero-subtitle">{subtitle || "No stress. Just fixes. Your Trusted Local Expert for Quality Home Repairs & Reliable Service."}</p>
        <div className="hero-cta-container">
          <a href="#contact" className="btn btn-primary">
            📅 Book Now
          </a>
          <a href="tel:+13107217974" className="btn btn-primary">
            📞 Call Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
